<script>
import { Event } from '@/plugins/bus';

export default {
    computed: {
        unitId() {
            return this.$route.params.unitId;
        },
    },
    methods: {
        async getCustomWarranties() {
            try {
                this.$wait.start('loading custom warranties');
                this.$wait.end('loading data');
                const response = await this.$api.get(`units/${this.unitId}/custom-warranties`);
                return response.data;
            } catch (error) {
                this.$toast.error('There was an error getting custom warranties');
                this.customWarranties = [];
            } finally {
                this.$wait.end('loading custom warranties');
                this.$wait.end('loading data');
            }
        },
        async addCustomWarranty(id, add) {
            try {
                this.loading = true;
                await this.$api.put(`units/${this.unitId || add.unitId}/custom-warranties/${id}`, add);
                this.$bus.$emit(Event.CustomWarrantyUpdated, { ...add, id });
                this.$toast.success(`'${add.description}' added`);
            } catch (err) {
                this.$toast.error(`Could not add '${add.description}'`);
            } finally {
                this.loading = false;
            }
        },
        async updateCustomWarranty(id, update) {
            try {
                this.loading = true;
                await this.$api.put(`units/${this.unitId}/custom-warranties/${id}`, update);
                this.$bus.$emit(Event.CustomWarrantyUpdated, update);
                this.$toast.success(`'${update.description}' updated`);
            } catch (err) {
                this.$toast.error(`Could not update '${update.description}'`);
                this.$toast.error(err);
            } finally {
                this.loading = false;
            }
        },
        async deleteCustomWarranty(customWarrantyId) {
            try {
                const response = await this.$api.delete(`units/${this.unitId}/custom-warranties/${customWarrantyId}`);
                this.$bus.$emit(Event.CustomWarrantyDeleted, response.data);
            } catch (err) {
                this.$toast.error(`Could not delete custom warranty`);
            } finally {
                this.$toast.success(`Custom warranty deleted`);
            }
        },
    }
};
</script>
